import React, {useState} from 'react';

export const ToastContext = React.createContext();

const ToastContextProvider = ({ children }) => {
  const [showToast, setShowToast] = useState(false);
  const [toast, setToast] = useState({ type: 'success', text: '', displayTime: 3000, close: false });

  const displayToast = (type, text, displayTime, close) => {
    setToast({ type, text, displayTime, close: !!close });
    setTimeout(() => {
      setShowToast(true);
    }, 200);
  };

  const closeToast = () => {
    setShowToast(false);
    setTimeout(() => {
      setToast({ type: 'success', text: '' });
    }, 2000);
  };

  return (
    <ToastContext.Provider
      value={{
        showToast,
        toast,
        displayToast,
        closeToast
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};

export default ToastContextProvider;
